export default [
  {
    path: '/login',
    name: 'Login',
    meta: { title: "登录",hideTab:true },
    component: () => import('@/views/login/index.vue')
  }
]